import configurationManager from "../modules/common/services/ConfigurationManager";

type EndpointKey = keyof typeof defaultEndpoints;

const createEndpoint = (key: EndpointKey, defaultPath: string) => {
    // Get bootstrap config dynamically (lazy loading)
    const bootstrapConfig = configurationManager.getBootstrapConfig();

    // First check for specific endpoint override in bootstrap config
    const specificEndpoint =
        bootstrapConfig?.[key as keyof typeof bootstrapConfig];

    if (typeof specificEndpoint === "string") {
        return specificEndpoint;
    }

    // If backendUrl is defined, use it with the default path
    const backendUrl = bootstrapConfig?.backendUrl;
    if (typeof backendUrl === "string") {
        return `${backendUrl}${defaultPath}`;
    }

    // If runtime config is loaded, but backendUrl is not defined,
    // resolve the endpoint using the default path relative to the origin
    if (bootstrapConfig && !backendUrl) {
        return `${window.location.origin}${defaultPath}`;
    }

    // For local development, use the default endpoint (runtime config not provided)
    return defaultEndpoints[key];
};

const defaultEndpoints = {
    tasksUrl: "http://localhost:5014/api/",
    pushUrl: "http://localhost:5014/hub/",
    reportsUrL: "http://localhost:5015/api/reports/",
} as const;

// Create a function that returns endpoints instead of computing them at module load time
const getEndpoints = () =>
    ({
        tasksUrl: createEndpoint("tasksUrl", "/backend/api/"),
        pushUrl: createEndpoint("pushUrl", "/backend/hub/"),
        reportsUrL: createEndpoint("reportsUrL", "/reporting/api/reports/"),
    }) as const;

// For backward compatibility, create a getter-based object
const endpoints = new Proxy({} as ReturnType<typeof getEndpoints>, {
    get(target, prop) {
        const computed = getEndpoints();
        return computed[prop as keyof typeof computed];
    },
});

export default endpoints;
